const inventDashData = {
  valuationData: {
    inEUR: {
      value: '31,250.00',
      color: 'tag.purple',
    },
    inRUB: {
      value: '3,093,750.00',
      color: 'tag.blue',
    },
  },
  readyStockData: [
    {
      title: 'Ready for EU',
      value: 49999,
      color: 'tag.green',
    },
    {title: '', value: 16000, color: 'tag.grey'},
  ],
  stockStatusData: [
    {
      name: 'In Warehouse',
      value: 302,
      color: 'tag.blue',
    },
    {
      name: 'Reserved',
      value: 450,
      color: 'tag.purple',
    },
    {
      name: 'Pending Docs',
      value: 274,
      color: 'tag.yellow',
    },
    {
      name: 'Ready for EU',
      value: 218,
      color: 'tag.green',
    },
  ],
  productData: [
    {
      name: 'Heavy Denim',
      quantity: 1030.0,
      change: '+30',
      color: 'tag.blue',
    },
    {
      name: 'Linen White',
      quantity: 1258.0,
      change: '+30',
      color: 'tag.grey',
    },
    {
      name: 'Poplin Red',
      quantity: 1202.2,
      change: -20,
      color: 'tag.red',
    },
    {
      name: 'Sateen Black',
      quantity: 1034.5,
      change: '+30',
      color: 'tag.slate',
    },
    {
      name: 'Sateen Navy',
      quantity: 1719.3,
      change: '+30',
      color: 'tag.navy',
    },
    {
      name: 'Single Jersey',
      quantity: 783.7,
      change: '+30',
      color: 'tag.yellow',
    },
  ],
  dyelotData: [
    {
      name: 'Sateen Black',
      count: 4,
      dyeLots: ['STBK-01', 'STBK-02', 'STBK-03', 'STBK-05'],
    },
    {
      name: 'Single Jersey',
      count: 4,
      dyeLots: ['GR-01', 'GR-02', 'GR-03', 'GR-05'],
    },
    {
      name: 'Heavy Denim',
      count: 3,
      dyeLots: ['DNM-01', 'DNM-02', 'DNM-04'],
    },
    {
      name: 'Linen White',
      count: 3,
      dyeLots: ['LNWT-01', 'LNWT-04', 'LNWT-05'],
    },
    {
      name: 'Sateen Navy',
      count: 2,
      dyeLots: ['STNV-02', 'STNV-04'],
    },
    {name: 'Poplin Red', count: 1, dyeLots: ['PPRD-05']},
  ],
};
export default inventDashData;
